import { CSSProperties } from "@material-ui/core/styles/withStyles";
import { colors } from "@clockwise/web-commons/src/styles/color.styles";

export const textField: CSSProperties = {
  "&.error": {
    "& input ~ fieldset": {
      borderColor: colors.red.standard,
    },
    "& input:focus ~ fieldset": {
      borderColor: colors.red.standard,
    },
    "& > p": {
      color: colors.red.standard,
    },
  },
  "&.valid": {
    "& input ~ fieldset": {
      borderColor: colors.green.standard,
    },
    "& input:focus ~ fieldset": {
      borderColor: colors.green.standard,
    },
    "& > p": {
      color: colors.green.standard,
    },
  },

  "& .input": {
    height: 40,
  },
};

export const styles = {
  textField,
};
